import { render, staticRenderFns } from "./ListOrganizers.vue?vue&type=template&id=229fc847&scoped=true"
import script from "./ListOrganizers.vue?vue&type=script&lang=js"
export * from "./ListOrganizers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229fc847",
  null
  
)

export default component.exports